<section class="mb-4">
  <nz-search-input
    [searchValue]="searchValue"
    (onSearchValueChange)="onSearch($event)"
    placeholder="Търсене по потребител или обява...">
  </nz-search-input>
</section>
<section class="mb-4">
  <nz-search-result
    [totalResults]="this.totalResults"
    [sortOptions]="sortOptions"
    [selectedSortOption]="selectedSortOption"
    (onSortOptionChange)="onSort($event)">
  </nz-search-result>
</section>
@if (!loading) {
  @if (userFeedbacks.length === 0) {
    <h4 class="my-5 text-muted">
      Няма намерени отзиви
    </h4>
  }
  <section>
    <ul class="list-unstyled" nzRestoreScrollPosition>
      @for (userFeedback of userFeedbacks; track userFeedback.userFeedbackId) {
        <li class="my-3 border d-flex shadow bg-white rounded-3">
          <div class="rounded-start-1 profile-card-image bg-light d-flex align-items-center justify-content-center">
            <h5 class="m-0"
                [ngClass]="userFeedback.percentage <= 25 ? 'text-danger' : userFeedback.percentage === 50 ? 'text-warning' : 'text-success'">
              {{ userFeedback.percentage }}%
            </h5>
          </div>
          <div class="p-2 w-100">
            <p class="m-0 pb-1">
              {{ userFeedback.comment }}
            </p>
            <div class="small text-muted">
              Потребител:
              <a class="text-decoration-none text-break"
                 [routerLink]="[appRoutes.root, appRoutes.profile, userFeedback.senderId]">
                {{ userFeedback.senderUsername }}
              </a>
            </div>
            <div class="small text-end text-muted">
              {{ userFeedback.dateTime | date: 'dd:MM:yyyy г. HH:mm ч.' }}
            </div>
          </div>
        </li>
      }
    </ul>
  </section>
} @else {
  <section class="my-5">
    <div class="text-center">
      <h1>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
@if (this.totalResults > defaultPageLimit) {
  <section class="py-4">
    <nz-pagination
      [totalResults]="totalResults"
      [selectedPage]="selectedPage"
      [selectedPageLimitOptionId]="selectedPageLimitOptionId"/>
  </section>
}
